/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LANGUAGE = "DANISH" | "ENGLISH_EU" | "ENGLISH_UK" | "ENGLISH_US" | "FRENCH" | "POLISH" | "SPANISH" | "%future added value";
export type UpdateViewerInput = {|
  email?: ?string,
  jobTitle?: ?string,
  firstName?: ?string,
  lastName?: ?string,
  phone?: ?string,
  initials?: ?string,
  userType?: ?string,
  roleId?: ?string,
  profileId?: ?string,
  departmentId?: ?string,
  holidayCalendarId?: ?string,
  language?: ?LANGUAGE,
  oldPassword?: ?string,
  newPassword?: ?string,
  labels?: ?$ReadOnlyArray<?string>,
  profilePictureId?: ?string,
  notificationFrequency?: ?number,
  notifyOnProjectStatusChange?: ?boolean,
  notifyOnPersonJoin?: ?boolean,
  notifyOnAssignedProject?: ?boolean,
  notifyOnProjectDeadline?: ?boolean,
  notifyOnAssignedTask?: ?boolean,
  notifyOnAssignedTaskUpdate?: ?boolean,
  notifyOnTaskDeadline?: ?boolean,
  notifyOnMention?: ?boolean,
  notifyOnTaskDescriptionChange?: ?boolean,
  notifyOnTaskTitleChange?: ?boolean,
  notifyOnTaskEstimateChange?: ?boolean,
  notifyOnTaskStartDateChange?: ?boolean,
  notifyOnTaskEndDateChange?: ?boolean,
  notifyOnTaskSprintChange?: ?boolean,
  notifyOnTaskPhaseChange?: ?boolean,
  notifyOnTaskStatusColumnChange?: ?boolean,
  notifyOnTaskProjectChange?: ?boolean,
  notifyOnTaskSubtaskChange?: ?boolean,
  notifyOnTaskSubtaskEstimateChange?: ?boolean,
  notifyOnTaskCommentChange?: ?boolean,
  notifyOnTaskFileChange?: ?boolean,
  notifyOnTaskBugChange?: ?boolean,
  notifyOnTaskBlockedChange?: ?boolean,
  notifyOnTaskRepeatingChange?: ?boolean,
  projectDeadlineNotificationPeriod?: ?number,
  taskDeadlineNotificationPeriod?: ?number,
  disableNotifications?: ?boolean,
  notifyInAppOnPersonJoin?: ?boolean,
  notifyInAppOnProjectStatusChange?: ?boolean,
  notifyInAppOnAssignedProject?: ?boolean,
  notifyInAppOnProjectDeadline?: ?boolean,
  notifyInAppOnAssignedTask?: ?boolean,
  notifyInAppOnAssignedTaskUpdate?: ?boolean,
  notifyInAppOnTaskDeadline?: ?boolean,
  notifyInAppOnMention?: ?boolean,
  notifyInAppOnTaskDescriptionChange?: ?boolean,
  notifyInAppOnTaskTitleChange?: ?boolean,
  notifyInAppOnTaskEstimateChange?: ?boolean,
  notifyInAppOnTaskStartDateChange?: ?boolean,
  notifyInAppOnTaskEndDateChange?: ?boolean,
  notifyInAppOnTaskSprintChange?: ?boolean,
  notifyInAppOnTaskPhaseChange?: ?boolean,
  notifyInAppOnTaskStatusColumnChange?: ?boolean,
  notifyInAppOnTaskProjectChange?: ?boolean,
  notifyInAppOnTaskSubtaskChange?: ?boolean,
  notifyInAppOnTaskSubtaskEstimateChange?: ?boolean,
  notifyInAppOnTaskCommentChange?: ?boolean,
  notifyInAppOnTaskFileChange?: ?boolean,
  notifyInAppOnTaskBugChange?: ?boolean,
  notifyInAppOnTaskBlockedChange?: ?boolean,
  notifyInAppOnTaskRepeatingChange?: ?boolean,
  lastSeenInAppNotification?: ?number,
  disableInAppNotifications?: ?boolean,
  disableCelebrationAnimations?: ?boolean,
  projectDeadlineInAppNotificationPeriod?: ?number,
  taskDeadlineInAppNotificationPeriod?: ?number,
  sendNewsletter?: ?boolean,
  monday?: ?number,
  tuesday?: ?number,
  wednesday?: ?number,
  thursday?: ?number,
  friday?: ?number,
  saturday?: ?number,
  sunday?: ?number,
  startDate?: ?string,
  endDate?: ?string,
  timerStartDate?: ?string,
  timerEndDate?: ?string,
  timerTaskId?: ?string,
  cost?: ?number,
  flowSampleStep?: ?string,
  timeLogPersonId?: ?string,
  githubPersonId?: ?string,
  gitlabPersonId?: ?string,
  gitlabServerPersonId?: ?string,
  jiraCloudId?: ?string,
  jiraServerId?: ?string,
  unit4PersonId?: ?string,
  onboardingInitialStep?: ?string,
  onboardingProjectPhasesStep?: ?string,
  onboardingProjectBudgetStep?: ?string,
  onboardingProjectBoardStep?: ?string,
  onboardingProjectOverviewStep?: ?string,
  onboardingTaskModalStep?: ?string,
  onboardingOverviewTimeStep?: ?string,
  setToRunningNotificationLastDismissalDate?: ?string,
  useNewUIWorkflow?: ?boolean,
  savedFiltersJson?: ?string,
  adminPassword?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type updateViewerMutationModernMutationVariables = {|
  input: UpdateViewerInput
|};
export type updateViewerMutationModernMutationResponse = {|
  +updateViewer: ?{|
    +errors: ?$ReadOnlyArray<?string>,
    +viewer: ?{|
      +email: ?string,
      +jobTitle: ?string,
      +department: ?{|
        +id: string,
        +name: ?string,
      |},
      +firstName: ?string,
      +lastName: ?string,
      +phone: ?string,
      +initials: ?string,
      +cost: ?number,
      +profiles: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +name: ?string,
          |}
        |}>
      |},
      +role: ?{|
        +id: string,
        +name: ?string,
      |},
      +holidayCalendar: ?{|
        +id: string
      |},
      +language: ?LANGUAGE,
      +invited: ?boolean,
      +profilePictureId: ?string,
      +personLabels: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +label: ?{|
              +id: string
            |}
          |}
        |}>
      |},
      +unseenNotifications: ?number,
      +notificationFrequency: ?number,
      +notifyOnPersonJoin: ?boolean,
      +notifyOnProjectStatusChange: ?boolean,
      +notifyOnAssignedProject: ?boolean,
      +notifyOnProjectDeadline: ?boolean,
      +notifyOnAssignedTask: ?boolean,
      +notifyOnAssignedTaskUpdate: ?boolean,
      +notifyOnTaskDeadline: ?boolean,
      +notifyOnMention: ?boolean,
      +notifyOnTaskDescriptionChange: ?boolean,
      +notifyOnTaskTitleChange: ?boolean,
      +notifyOnTaskEstimateChange: ?boolean,
      +notifyOnTaskStartDateChange: ?boolean,
      +notifyOnTaskEndDateChange: ?boolean,
      +notifyOnTaskSprintChange: ?boolean,
      +notifyOnTaskPhaseChange: ?boolean,
      +notifyOnTaskStatusColumnChange: ?boolean,
      +notifyOnTaskProjectChange: ?boolean,
      +notifyOnTaskSubtaskChange: ?boolean,
      +notifyOnTaskSubtaskEstimateChange: ?boolean,
      +notifyOnTaskCommentChange: ?boolean,
      +notifyOnTaskFileChange: ?boolean,
      +notifyOnTaskBugChange: ?boolean,
      +notifyOnTaskBlockedChange: ?boolean,
      +notifyOnTaskRepeatingChange: ?boolean,
      +disableNotifications: ?boolean,
      +projectDeadlineNotificationPeriod: ?number,
      +taskDeadlineNotificationPeriod: ?number,
      +notifyInAppOnProjectStatusChange: ?boolean,
      +notifyInAppOnPersonJoin: ?boolean,
      +notifyInAppOnAssignedProject: ?boolean,
      +notifyInAppOnProjectDeadline: ?boolean,
      +notifyInAppOnAssignedTask: ?boolean,
      +notifyInAppOnAssignedTaskUpdate: ?boolean,
      +notifyInAppOnTaskDeadline: ?boolean,
      +notifyInAppOnMention: ?boolean,
      +notifyInAppOnTaskDescriptionChange: ?boolean,
      +notifyInAppOnTaskTitleChange: ?boolean,
      +notifyInAppOnTaskEstimateChange: ?boolean,
      +notifyInAppOnTaskStartDateChange: ?boolean,
      +notifyInAppOnTaskEndDateChange: ?boolean,
      +notifyInAppOnTaskSprintChange: ?boolean,
      +notifyInAppOnTaskPhaseChange: ?boolean,
      +notifyInAppOnTaskStatusColumnChange: ?boolean,
      +notifyInAppOnTaskProjectChange: ?boolean,
      +notifyInAppOnTaskSubtaskChange: ?boolean,
      +notifyInAppOnTaskSubtaskEstimateChange: ?boolean,
      +notifyInAppOnTaskCommentChange: ?boolean,
      +notifyInAppOnTaskFileChange: ?boolean,
      +notifyInAppOnTaskBugChange: ?boolean,
      +notifyInAppOnTaskBlockedChange: ?boolean,
      +notifyInAppOnTaskRepeatingChange: ?boolean,
      +disableInAppNotifications: ?boolean,
      +projectDeadlineInAppNotificationPeriod: ?number,
      +taskDeadlineInAppNotificationPeriod: ?number,
      +lastSeenInAppNotification: ?number,
      +sendNewsletter: ?boolean,
      +monday: ?number,
      +tuesday: ?number,
      +wednesday: ?number,
      +thursday: ?number,
      +friday: ?number,
      +saturday: ?number,
      +sunday: ?number,
      +startDate: ?string,
      +endDate: ?string,
      +timerStartDate: ?string,
      +timerEndDate: ?string,
      +timerTask: ?{|
        +id: string
      |},
      +setToRunningNotificationLastDismissalDate: ?string,
      +timeLogUser: ?{|
        +integrationUserId: ?number
      |},
      +gitlabUser: ?{|
        +integrationUserId: ?number
      |},
      +gitlabServerUser: ?{|
        +integrationUserId: ?number
      |},
      +githubUser: ?{|
        +integrationUserId: ?number
      |},
      +unit4UserObject: ?string,
      +jiraCloudId: ?string,
      +jiraServerId: ?string,
    |},
  |}
|};
export type updateViewerMutationModernMutation = {|
  variables: updateViewerMutationModernMutationVariables,
  response: updateViewerMutationModernMutationResponse,
|};
*/


/*
mutation updateViewerMutationModernMutation(
  $input: UpdateViewerInput!
) {
  updateViewer(input: $input) {
    errors
    viewer {
      email
      jobTitle
      department {
        id
        name
      }
      firstName
      lastName
      phone
      initials
      cost
      profiles(first: 10000) {
        edges {
          node {
            id
            name
          }
        }
      }
      role {
        id
        name
      }
      holidayCalendar {
        id
      }
      language
      invited
      profilePictureId
      personLabels(first: 10000) {
        edges {
          node {
            label {
              id
            }
            id
          }
        }
      }
      unseenNotifications
      notificationFrequency
      notifyOnPersonJoin
      notifyOnProjectStatusChange
      notifyOnAssignedProject
      notifyOnProjectDeadline
      notifyOnAssignedTask
      notifyOnAssignedTaskUpdate
      notifyOnTaskDeadline
      notifyOnMention
      notifyOnTaskDescriptionChange
      notifyOnTaskTitleChange
      notifyOnTaskEstimateChange
      notifyOnTaskStartDateChange
      notifyOnTaskEndDateChange
      notifyOnTaskSprintChange
      notifyOnTaskPhaseChange
      notifyOnTaskStatusColumnChange
      notifyOnTaskProjectChange
      notifyOnTaskSubtaskChange
      notifyOnTaskSubtaskEstimateChange
      notifyOnTaskCommentChange
      notifyOnTaskFileChange
      notifyOnTaskBugChange
      notifyOnTaskBlockedChange
      notifyOnTaskRepeatingChange
      disableNotifications
      projectDeadlineNotificationPeriod
      taskDeadlineNotificationPeriod
      notifyInAppOnProjectStatusChange
      notifyInAppOnPersonJoin
      notifyInAppOnAssignedProject
      notifyInAppOnProjectDeadline
      notifyInAppOnAssignedTask
      notifyInAppOnAssignedTaskUpdate
      notifyInAppOnTaskDeadline
      notifyInAppOnMention
      notifyInAppOnTaskDescriptionChange
      notifyInAppOnTaskTitleChange
      notifyInAppOnTaskEstimateChange
      notifyInAppOnTaskStartDateChange
      notifyInAppOnTaskEndDateChange
      notifyInAppOnTaskSprintChange
      notifyInAppOnTaskPhaseChange
      notifyInAppOnTaskStatusColumnChange
      notifyInAppOnTaskProjectChange
      notifyInAppOnTaskSubtaskChange
      notifyInAppOnTaskSubtaskEstimateChange
      notifyInAppOnTaskCommentChange
      notifyInAppOnTaskFileChange
      notifyInAppOnTaskBugChange
      notifyInAppOnTaskBlockedChange
      notifyInAppOnTaskRepeatingChange
      disableInAppNotifications
      projectDeadlineInAppNotificationPeriod
      taskDeadlineInAppNotificationPeriod
      lastSeenInAppNotification
      sendNewsletter
      monday
      tuesday
      wednesday
      thursday
      friday
      saturday
      sunday
      startDate
      endDate
      timerStartDate
      timerEndDate
      timerTask {
        id
      }
      setToRunningNotificationLastDismissalDate
      timeLogUser {
        integrationUserId
      }
      gitlabUser {
        integrationUserId
      }
      gitlabServerUser {
        integrationUserId
      }
      githubUser {
        integrationUserId
      }
      unit4UserObject
      jiraCloudId
      jiraServerId
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateViewerInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jobTitle",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "DepartmentType",
  "kind": "LinkedField",
  "name": "department",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phone",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "initials",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cost",
  "storageKey": null
},
v13 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v14 = {
  "alias": null,
  "args": (v13/*: any*/),
  "concreteType": "ProfileTypeConnection",
  "kind": "LinkedField",
  "name": "profiles",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfileTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v6/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "profiles(first:10000)"
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v16 = [
  (v5/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "HolidayCalendar",
  "kind": "LinkedField",
  "name": "holidayCalendar",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invited",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Label",
  "kind": "LinkedField",
  "name": "label",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unseenNotifications",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notificationFrequency",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnPersonJoin",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnProjectStatusChange",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnAssignedProject",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnProjectDeadline",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnAssignedTask",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnAssignedTaskUpdate",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskDeadline",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnMention",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskDescriptionChange",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskTitleChange",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskEstimateChange",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskStartDateChange",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskEndDateChange",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskSprintChange",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskPhaseChange",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskStatusColumnChange",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskProjectChange",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskSubtaskChange",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskSubtaskEstimateChange",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskCommentChange",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskFileChange",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskBugChange",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskBlockedChange",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskRepeatingChange",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableNotifications",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectDeadlineNotificationPeriod",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskDeadlineNotificationPeriod",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnProjectStatusChange",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnPersonJoin",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnAssignedProject",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnProjectDeadline",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnAssignedTask",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnAssignedTaskUpdate",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskDeadline",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnMention",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskDescriptionChange",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskTitleChange",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskEstimateChange",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskStartDateChange",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskEndDateChange",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskSprintChange",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskPhaseChange",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskStatusColumnChange",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskProjectChange",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskSubtaskChange",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskSubtaskEstimateChange",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskCommentChange",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskFileChange",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskBugChange",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskBlockedChange",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskRepeatingChange",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableInAppNotifications",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectDeadlineInAppNotificationPeriod",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskDeadlineInAppNotificationPeriod",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSeenInAppNotification",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sendNewsletter",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "monday",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tuesday",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wednesday",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thursday",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "friday",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "saturday",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sunday",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timerStartDate",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timerEndDate",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "timerTask",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "setToRunningNotificationLastDismissalDate",
  "storageKey": null
},
v93 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "integrationUserId",
    "storageKey": null
  }
],
v94 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationUserType",
  "kind": "LinkedField",
  "name": "timeLogUser",
  "plural": false,
  "selections": (v93/*: any*/),
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationUserType",
  "kind": "LinkedField",
  "name": "gitlabUser",
  "plural": false,
  "selections": (v93/*: any*/),
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationUserType",
  "kind": "LinkedField",
  "name": "gitlabServerUser",
  "plural": false,
  "selections": (v93/*: any*/),
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationUserType",
  "kind": "LinkedField",
  "name": "githubUser",
  "plural": false,
  "selections": (v93/*: any*/),
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit4UserObject",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraCloudId",
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraServerId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateViewerMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateViewerPayload",
        "kind": "LinkedField",
        "name": "updateViewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": (v13/*: any*/),
                "concreteType": "PersonLabelTypeConnection",
                "kind": "LinkedField",
                "name": "personLabels",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonLabelTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PersonLabel",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "personLabels(first:10000)"
              },
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/),
              (v47/*: any*/),
              (v48/*: any*/),
              (v49/*: any*/),
              (v50/*: any*/),
              (v51/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/),
              (v54/*: any*/),
              (v55/*: any*/),
              (v56/*: any*/),
              (v57/*: any*/),
              (v58/*: any*/),
              (v59/*: any*/),
              (v60/*: any*/),
              (v61/*: any*/),
              (v62/*: any*/),
              (v63/*: any*/),
              (v64/*: any*/),
              (v65/*: any*/),
              (v66/*: any*/),
              (v67/*: any*/),
              (v68/*: any*/),
              (v69/*: any*/),
              (v70/*: any*/),
              (v71/*: any*/),
              (v72/*: any*/),
              (v73/*: any*/),
              (v74/*: any*/),
              (v75/*: any*/),
              (v76/*: any*/),
              (v77/*: any*/),
              (v78/*: any*/),
              (v79/*: any*/),
              (v80/*: any*/),
              (v81/*: any*/),
              (v82/*: any*/),
              (v83/*: any*/),
              (v84/*: any*/),
              (v85/*: any*/),
              (v86/*: any*/),
              (v87/*: any*/),
              (v88/*: any*/),
              (v89/*: any*/),
              (v90/*: any*/),
              (v91/*: any*/),
              (v92/*: any*/),
              (v94/*: any*/),
              (v95/*: any*/),
              (v96/*: any*/),
              (v97/*: any*/),
              (v98/*: any*/),
              (v99/*: any*/),
              (v100/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateViewerMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateViewerPayload",
        "kind": "LinkedField",
        "name": "updateViewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": (v13/*: any*/),
                "concreteType": "PersonLabelTypeConnection",
                "kind": "LinkedField",
                "name": "personLabels",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonLabelTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PersonLabel",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "personLabels(first:10000)"
              },
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/),
              (v47/*: any*/),
              (v48/*: any*/),
              (v49/*: any*/),
              (v50/*: any*/),
              (v51/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/),
              (v54/*: any*/),
              (v55/*: any*/),
              (v56/*: any*/),
              (v57/*: any*/),
              (v58/*: any*/),
              (v59/*: any*/),
              (v60/*: any*/),
              (v61/*: any*/),
              (v62/*: any*/),
              (v63/*: any*/),
              (v64/*: any*/),
              (v65/*: any*/),
              (v66/*: any*/),
              (v67/*: any*/),
              (v68/*: any*/),
              (v69/*: any*/),
              (v70/*: any*/),
              (v71/*: any*/),
              (v72/*: any*/),
              (v73/*: any*/),
              (v74/*: any*/),
              (v75/*: any*/),
              (v76/*: any*/),
              (v77/*: any*/),
              (v78/*: any*/),
              (v79/*: any*/),
              (v80/*: any*/),
              (v81/*: any*/),
              (v82/*: any*/),
              (v83/*: any*/),
              (v84/*: any*/),
              (v85/*: any*/),
              (v86/*: any*/),
              (v87/*: any*/),
              (v88/*: any*/),
              (v89/*: any*/),
              (v90/*: any*/),
              (v91/*: any*/),
              (v92/*: any*/),
              (v94/*: any*/),
              (v95/*: any*/),
              (v96/*: any*/),
              (v97/*: any*/),
              (v98/*: any*/),
              (v99/*: any*/),
              (v100/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateViewerMutationModernMutation",
    "operationKind": "mutation",
    "text": "mutation updateViewerMutationModernMutation(\n  $input: UpdateViewerInput!\n) {\n  updateViewer(input: $input) {\n    errors\n    viewer {\n      email\n      jobTitle\n      department {\n        id\n        name\n      }\n      firstName\n      lastName\n      phone\n      initials\n      cost\n      profiles(first: 10000) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n      role {\n        id\n        name\n      }\n      holidayCalendar {\n        id\n      }\n      language\n      invited\n      profilePictureId\n      personLabels(first: 10000) {\n        edges {\n          node {\n            label {\n              id\n            }\n            id\n          }\n        }\n      }\n      unseenNotifications\n      notificationFrequency\n      notifyOnPersonJoin\n      notifyOnProjectStatusChange\n      notifyOnAssignedProject\n      notifyOnProjectDeadline\n      notifyOnAssignedTask\n      notifyOnAssignedTaskUpdate\n      notifyOnTaskDeadline\n      notifyOnMention\n      notifyOnTaskDescriptionChange\n      notifyOnTaskTitleChange\n      notifyOnTaskEstimateChange\n      notifyOnTaskStartDateChange\n      notifyOnTaskEndDateChange\n      notifyOnTaskSprintChange\n      notifyOnTaskPhaseChange\n      notifyOnTaskStatusColumnChange\n      notifyOnTaskProjectChange\n      notifyOnTaskSubtaskChange\n      notifyOnTaskSubtaskEstimateChange\n      notifyOnTaskCommentChange\n      notifyOnTaskFileChange\n      notifyOnTaskBugChange\n      notifyOnTaskBlockedChange\n      notifyOnTaskRepeatingChange\n      disableNotifications\n      projectDeadlineNotificationPeriod\n      taskDeadlineNotificationPeriod\n      notifyInAppOnProjectStatusChange\n      notifyInAppOnPersonJoin\n      notifyInAppOnAssignedProject\n      notifyInAppOnProjectDeadline\n      notifyInAppOnAssignedTask\n      notifyInAppOnAssignedTaskUpdate\n      notifyInAppOnTaskDeadline\n      notifyInAppOnMention\n      notifyInAppOnTaskDescriptionChange\n      notifyInAppOnTaskTitleChange\n      notifyInAppOnTaskEstimateChange\n      notifyInAppOnTaskStartDateChange\n      notifyInAppOnTaskEndDateChange\n      notifyInAppOnTaskSprintChange\n      notifyInAppOnTaskPhaseChange\n      notifyInAppOnTaskStatusColumnChange\n      notifyInAppOnTaskProjectChange\n      notifyInAppOnTaskSubtaskChange\n      notifyInAppOnTaskSubtaskEstimateChange\n      notifyInAppOnTaskCommentChange\n      notifyInAppOnTaskFileChange\n      notifyInAppOnTaskBugChange\n      notifyInAppOnTaskBlockedChange\n      notifyInAppOnTaskRepeatingChange\n      disableInAppNotifications\n      projectDeadlineInAppNotificationPeriod\n      taskDeadlineInAppNotificationPeriod\n      lastSeenInAppNotification\n      sendNewsletter\n      monday\n      tuesday\n      wednesday\n      thursday\n      friday\n      saturday\n      sunday\n      startDate\n      endDate\n      timerStartDate\n      timerEndDate\n      timerTask {\n        id\n      }\n      setToRunningNotificationLastDismissalDate\n      timeLogUser {\n        integrationUserId\n      }\n      gitlabUser {\n        integrationUserId\n      }\n      gitlabServerUser {\n        integrationUserId\n      }\n      githubUser {\n        integrationUserId\n      }\n      unit4UserObject\n      jiraCloudId\n      jiraServerId\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fe0a57f86350ab53217f390477104944';

module.exports = node;
